import { XBuildifyPermissionSelection } from '@adornis/buildify/client/components/x-buildify-permission-selection.js';
import { customElement } from 'lit/decorators.js';

@customElement('cr-buildify-permission-selection')
export class CRBuildifyPermissionSelection extends XBuildifyPermissionSelection {}
